import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import shallowequal from "shallowequal";
import { List, Rate, Button } from "antd";
import { MyIcon, noDataImg } from "../../common/baseConfig";
import moment from "moment"
export class StartExerExam extends Component {
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    curPage: 1,
    store: -1,
  }
  componentDidMount() {
    const { fetchGetQuestionStoreSelect } = this.props.center;
    if (fetchGetQuestionStoreSelect) {
      let store = fetchGetQuestionStoreSelect.storeID;
      this.setState({
        store,
        curPage: 1,
      }, () => {
        this.onLoadExam();
      })
    }
  }
  componentWillReceiveProps(nextProps) {

    if (!shallowequal(this.props.center.fetchGetQuestionStoreSelect, nextProps.center.fetchGetQuestionStoreSelect)) {
      const { fetchGetQuestionStoreSelect } = nextProps.center;
      let store = fetchGetQuestionStoreSelect.storeID;
      this.setState({
        store,
        curPage: 1,
      }, () => {
        this.onLoadExam();
      })
    }
  }
  onLoadExam() {
    this.props.actions.fetchGetExamPaperList({
      PageSize: 5,
      PageIndex: this.state.curPage,
      PageStatus: 1,
      store: this.state.store,
      type: 0,
      Valid: 1,
    })
  }
  onCollect(ID) {
    this.props.actions.fetchAddCollecton({
      BusID: ID,
      BusType: 1
    }).then(res => {
      if (res.SuccessResponse) {
        this.onLoadExam();
      }
    })
  }
  renderItem(item, key) {
    return (
      <div key={key} className="exam-item">
        <h1>
          <p>
            <span>【模拟考试】</span><span>{item.Title}</span>
          </p>
          <Rate disabled defaultValue={item.Level} className="rate" />
          <p>
            {`${item.DoCount}人做过 ${moment(new Date(item.AddTime)).format('YYYY-MM-DD')}`}
          </p>
        </h1>
        <div className="btns">
          <p className="collect" onClick={() => {
            this.onCollect(item.ID);
          }}><MyIcon className={item.Iscollection === 1 ? "collect-active" : ""} type="iconshoucang" /><span>{item.Iscollection === 1 ? "已" : ""}收藏</span></p>
          <Button type="theme" className="doExer" onClick={() => {
            // this.props.history.push(`/exer/exam/detail/${item.ID}`);
            this.props.history.push(`/ques/prepare/${item.ID}`);
          }}>做题</Button>
        </div>
      </div>
    )
  }
  render() {
    const { fetchGetExamPaperListSuccess, fetchGetExamPaperListPending, fetchGetExamPaperListTotal } = this.props.center;

    return (
      <div className="center-start-exer-exam">
        {
          fetchGetExamPaperListSuccess && fetchGetExamPaperListSuccess.length > 0 ?
            <div className="exam-list">
              <List
                itemLayout="horizontal"
                size="large"
                pagination={{
                  onChange: page => {
                    this.setState({
                      curPage: page,
                    }, () => {
                      this.onLoadExam();
                    })
                  },
                  current: this.state.curPage,
                  total: fetchGetExamPaperListTotal,
                  pageSize: 5,
                }}
                loading={fetchGetExamPaperListPending}
                dataSource={fetchGetExamPaperListSuccess}
                renderItem={(item, key) => this.renderItem(item, key)}
              />
            </div> : <div className="nodata">
              <img src={noDataImg} alt="" />
              <p>资源部小伙伴们，快马加鞭制作中......</p>
              <p>敬请期待</p>
            </div>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StartExerExam);



// WEBPACK FOOTER //
// ./src/features/center/StartExerExam.js